import * as React from "react";
import { ZeroData, ZeroDataActionType } from "azure-devops-ui/ZeroData";

export default class ZeroDataButtonExample extends React.Component<any, any> {
    public render(): JSX.Element {
        return (
            <div>
                <ZeroData
                    primaryText="This is the primary text"
                    secondaryText={
                        <span>
                            This secondary text contains a{" "}
                            <a
                                rel="nofollow noopener"
                                target="_blank"
                                href="https://bing.com"
                                aria-label="link to bing.com"
                            >
                                link
                            </a>{" "}
                            to somewhere else. Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit.
                        </span>
                    }
                    imageAltText="Bars"
                    imagePath={require("./bars.png")}
                    actionText="Button"
                    actionType={ZeroDataActionType.ctaButton}
                    onActionClick={(event, item) =>
                        alert("Hey, you clicked the button for " + item!.primaryText)
                    }
                />
            </div>
        );
    }
}
